export enum SenderIdClaims {
    AssociatedAccount = 'cr:AssociatedAccount',
    ComRegAdmin = 'cr:SenderId:IsComRegAdmin',
  }

